import React from 'react'
import "./OnBoarding.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';



export default function UserInfo() {
  return (
    <div className='userinfo_wrapper pt-4'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-6 form_center text-center'>
            <div className='userinfo_form_block'>
              <h5 className='fill_info_head'>Fill your basic information</h5>
              <p className='fill_info_para'>Please provide your organization information accurately,  it will be used in all
              your communications on this platform.</p>
              <Form name="information" className="form_info">
                  <div className="form-control-info">
                    <input type="text" name="name" className="form-input" placeholder="none" required=""/>
                    <Form.Label className='form-label'>First name</Form.Label>
                  </div>
                  <div className="form-control-info">
                    <input type="text" name="email" className="form-input" placeholder="none" required=""/>
                    <Form.Label className='form-label'>Last name</Form.Label>

                  </div>
                  <div className="form-control-info">
                    <input type="text" name="Company Name" className="form-input" placeholder="none" required=""/>
                    <Form.Label className='form-label'>Company name</Form.Label>
                  </div>
                  <div className="form-control-info">
                    <input type="email" name="email" className="form-input" placeholder="none" required=""/>
                    <Form.Label className='form-label'>Company Email</Form.Label>
                  </div>
                  <div className="form-control-info">
                    <input type="text" name="email" className="form-input" placeholder="none" required=""/>
                    <Form.Label className='form-label'>Designation</Form.Label>
                  </div>
                  <div className="form-control-info">
                    <input type="text" name="email" className="form-input" placeholder="none" required=""/>
                    <Form.Label className='form-label'>Department</Form.Label>

                  </div>
             
                  <div className="form-control-info">
                    <input type="text" name="email" className="form-input" placeholder="none" required=""/>
                    <label for="text" className="form-label">Your Contact </label>
                  </div>
               
                  <div className="form-control-info">
                  <Form.Select aria-label="Default select example" className='custom_info_select'>
                    <option>Country</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Form.Select>
                  </div>

                  <div className="d-grid gap-2">
                    <Button className="next_disabled">
                      Next
                    </Button>
                  </div>        
            </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
